interface RecentUsageProps {
  recentUsage: number | undefined;
}

export function RecentUsage({ recentUsage = 0 }: RecentUsageProps) {
  const formattedUsage = (recentUsage || 0).toLocaleString();
  
  return (
    <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
      <span className="text-sm text-muted-foreground">
        {formattedUsage} tokens brukt siste 24t
      </span>
    </div>
  );
}